(() => {
  if (window.__churaVariantsMotion) return;
  window.__churaVariantsMotion = true;
  const setups = new WeakMap();
  function setup(root) {
    if (setups.has(root)) return;
    const elements = [...root.querySelectorAll('[data-reveal]')];
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(el => el.classList.add('is-visible','revealed'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible','revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {threshold:0.08});
    elements.forEach(el => observer.observe(el));
    root.classList.add('motion-ready');
    setups.set(root,observer);
  }
  function initialize(scope = document) {
    scope.querySelectorAll('[data-chura-variant-root]').forEach(setup);
  }
  initialize();
  document.addEventListener('shopify:section:load',event => initialize(event.target));
  document.addEventListener('shopify:section:unload',event => {
    event.target.querySelectorAll('[data-chura-variant-root]').forEach(root => {
      setups.get(root)?.disconnect();
      setups.delete(root);
    });
  });
})();
